module.exports = __webpack_public_path__ + "static/media/20.0b2752e9.jfif";